import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function BookOnline() {
  const steps = [{
    num: '1',
    title: 'Book a cleaning',
    desc: 'Select your preferred date and time online in just a few clicks.'
  }, {
    num: '2',
    title: 'Confirm booking',
    desc: 'Receive an instant confirmation and details about your cleaner.'
  }, {
    num: '3',
    title: "We'll clean it",
    desc: 'Our vetted professionals will make your space shine.'
  }];
  return <section id="book-online" className="w-full bg-white py-20 px-6 md:px-12 overflow-hidden" data-id="element-47">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-48">
        {/* Left Content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="flex flex-col" data-id="element-49">
          <div className="flex justify-between items-start mb-12" data-id="element-50">
            <h2 className="text-6xl md:text-8xl font-bebas text-[#1a2744] leading-none tracking-wide" data-id="element-51">
              BOOK
              <br data-id="element-52" />
              ONLINE
            </h2>
            <div className="text-right mt-4" data-id="element-53">
              <span className="font-serif-playfair text-xl text-[#1a2744] italic block" data-id="element-54">
                Fast & Secure
              </span>
              <p className="text-sm text-gray-500 max-w-[200px] mt-2 text-right" data-id="element-55">
                Our seamless booking system makes scheduling your cleaning
                easier than ever before.
              </p>
            </div>
          </div>

          <div className="space-y-8" data-id="element-56">
            {steps.map((step, idx) => <motion.div key={step.num} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: idx * 0.2
          }} className="flex items-start gap-6 border-b border-gray-200 pb-6 last:border-0" data-id="element-57">
                <div className="w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center flex-shrink-0" data-id="element-58">
                  <span className="font-bebas text-2xl text-gray-400" data-id="element-59">
                    {step.num}
                  </span>
                </div>
                <div data-id="element-60">
                  <h3 className="text-xl font-bold text-[#1a2744] mb-1" data-id="element-61">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-62">{step.desc}</p>
                </div>
              </motion.div>)}
          </div>

          {/* Book a Service CTA */}
          <div className="mt-12 space-y-4" data-id="element-63">
            <p className="text-sm font-medium text-gray-500 uppercase tracking-wider" data-id="element-64">
              Choose a service to book
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-65">
              {[{
              label: 'Basic Home Cleaning',
              to: '/basic-home-cleaning-quote'
            }, {
              label: 'Commercial Cleaning',
              to: '/commercial-cleaning-quote'
            }, {
              label: 'Spring / Deep Cleaning',
              to: '/spring-deep-cleaning-quote'
            }, {
              label: 'Move-In / Move-Out',
              to: '/move-in-move-out-quote'
            }, {
              label: 'Airbnb / Short Term Rental',
              to: '/airbnb-quote'
            }, {
              label: 'Post Renovation',
              to: '/post-renovation-quote'
            }].map(service => <Link key={service.to} to={service.to} className="group flex items-center justify-between px-5 py-3.5 rounded-xl border border-gray-200 hover:border-[#e91e8c] hover:bg-[#e91e8c]/5 transition-all text-sm font-medium text-[#1a2744] hover:text-[#e91e8c]" data-id="element-66">
                  {service.label}
                  <ArrowRightIcon className="w-4 h-4 text-gray-400 group-hover:text-[#e91e8c] group-hover:translate-x-0.5 transition-all" data-id="element-67" />
                </Link>)}
            </div>
          </div>
        </motion.div>

        {/* Right Image */}
        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="relative h-[500px] lg:h-[700px] w-full" data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/qBXGYs2Lvqbd8Z4NQFbpsd/bathroom-victorian.jpg" alt="Elegant Victorian bathroom showcasing Smith and Jengs cleaning results" className="w-full h-full object-cover rounded-sm" loading="lazy" decoding="async" width={873} height={1200} data-id="element-69" />
          {/* Carousel dots mock */}
          <div className="absolute bottom-6 right-6 flex gap-2" data-id="element-70"></div>
        </motion.div>
      </div>
    </section>;
}